<div class="wrapper">
  <p-card>
    <h3>Type New Password:</h3>
    <app-password-input label="Password" [control]="password" [hint]="passwordLengthHint">
    </app-password-input>

    <h3>Verify Password:</h3>
    <app-password-input
      label="Retype Password"
      [control]="retypedPassword"
      (keyup)="handleKeyUp($event)"
    >
    </app-password-input>

    <div *ngIf="hasError" class="error-container">
      <p class="error-msg">{{ error }}</p>
    </div>

    <div class="submit-btn-container">
      <button
        pButton
        pRipple
        type="button"
        [loading]="didSubmit"
        label="Change Password"
        (click)="onSubmit()"
      ></button>
    </div>
  </p-card>
</div>
